import ErrorIcon from '@acorn-portal/shared/src/assets/shared/icons/base/broken-down-car.svg?react';
import { Box, ButtonBase, Fade, Typography } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router';

const ErrorPage: FC = () => {
	const navigate = useNavigate();
	return (
		<Fade in>
			<Box>
				<Box
					sx={(theme) => ({
						display: 'flex',
						flexDirection: { xs: 'column', md: 'row' },
						minHeight: '500px',
						px: {
							xs: '1.5em',
							md: '0',
						},
						flex: 1,
						justifyContent: 'center',
						alignItems: 'center',

						'& div:first-of-type': {
							flexBasis: '40em',
							[theme.breakpoints.down('md')]: {
								flexBasis: 'auto',
								'& h2': {
									fontSize: '2rem',
								},
								'& h5': {
									fontSize: '1rem',
								},
							},
						},
					})}
				>
					<Box>
						<Typography variant='h2' color='primary' sx={{ lineHeight: 'unset' }}>
							Something went wrong!
						</Typography>
						<Typography variant='h5' color='primary'>
							An error occurred while processing your request. Please go back to the{' '}
							<ButtonBase
								sx={(theme) => ({
									fontSize: 'inherit',
									verticalAlign: 'unset',
									padding: 0,
									color: theme.palette.primary.main,
									textDecoration: 'underline',
									'&:hover': {
										color: theme.palette.primary.light,
									},
									'&:visited': {
										color: theme.palette.primary.main,
										'&:hover': {
											color: theme.palette.primary.light,
										},
									},
								})}
								onClick={() => navigate('/portal/home', { replace: true })}
							>
								{' '}
								home page
							</ButtonBase>{' '}
							and try again.
						</Typography>
					</Box>
					<Box
						sx={{
							svg: {
								width: '20em',
								marginTop: { xs: '3em', md: '0' },
								maxWidth: { xs: '220px', md: 'none' },
								marginLeft: { xs: '0', md: '5em' },
							},
						}}
					>
						<ErrorIcon />
					</Box>
				</Box>
			</Box>
		</Fade>
	);
};

export default ErrorPage;
